import Vue from 'vue';
import { mapState } from 'vuex';
import yotpo from 'lib/yotpo';
import debounce from 'lodash/debounce';
import store from 'store';
import on from 'dom-event';
import { isTablet, getClosest } from 'utils/general';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import inViewport from 'in-viewport';
import {Autoplay, Navigation, A11y, Keyboard} from "swiper/modules";

export default (el) =>
  new Vue({
    components: {
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
      'vue-swiper': () => import('../vue-swiper/vue-swiper.vue'),
    },
    el,
    store,
    data() {
      return {
        albumName: '',
        media: [],
        swiperOptions: {
          slidesPerView: 1,
          spaceBetween: 60,
          a11y: true,
          keyboard: true,
          breakpoints: {
            1024: {
              slidesPerView: 'auto',
              centeredSlides: true
            }
          },
          loop: true,
          autoplay: {
            delay: 5000
          },
          navigation: {
            nextEl: '.ugc-slider__btn--next',
            prevEl: '.ugc-slider__btn--previous',
          },
          modules: [Navigation, Autoplay, A11y, Keyboard]
        },
        showModal: false,
        currentMediaIndex: 0,
      };
    },
    mounted() {
      inViewport(this.$el, () => {
        this.initAlbum();
        this.fetchAlbum();
        this.bindCloseEvent();
      });
    },
    updated() {
      this.rerenderSlider();
    },
    computed: {
      ...mapState('global', ['UGC']),
      currentMedia() {
        return this.media[this.currentMediaIndex];
      },
      isCurrentVideo() {
        return this.isVideo(this.currentMedia);
      },
    },
    methods: {
      initAlbum() {
        this.albumName = el.dataset.album;
      },
      fetchAlbum() {
        if (this.albumName === '') return;
        yotpo.getMediaByAlbum(this.albumName).then((res) => {
          if (res?.status?.code === 200) {
            const { images, pagination } = res.response;
            this.media = [...images];
            this.$nextTick(this.initSlider);
          }
        });
      },
      initSlider() {
        on(window, 'resize', debounce(this.onResize, 300));
      },
      next() {
        this.$refs.carousel.$swiper.slideNext();
      },
      previous() {
        this.$refs.carousel.$swiper.slidePrev();
      },
      rerenderSlider() {
        const { carousel } = this.$refs;
        if (carousel) carousel.$swiper.update();
      },
      onResize() {
        if (!this.hasSlider) return;
        this.$nextTick(this.rerenderSlider);
      },
      isVideo(item) {
        return item?.media_type === 'video';
      },
      getImageUrl(item, highQuality = false) {
        if (this.isVideo(item)) {
          const size = 285;
          // https://developer.kaltura.com/api-docs/Engage_and_Publish/kaltura-thumbnail-api.html
          // Creates a spritesheet to be animated with css
          return `${item.thumbnail_url}/width/${size}/vid_slices/4`;
        }
        const url = highQuality
          ? item.medium_image_url
          : item.low_resolution_image_url;
        return url;
      },
      openModal(index) {
        this.currentMediaIndex = index;
        this.showModal = true;
        this.$nextTick(() => {
          disableBodyScroll(this.$refs.mediaModal);
        });
      },
      closeModal() {
        this.showModal = false;
        clearAllBodyScrollLocks();
      },
      nextMedia() {
        if (this.currentMediaIndex + 1 >= this.media.length) {
          this.currentMediaIndex = 0;
        } else {
          this.currentMediaIndex += 1;
        }
      },
      previousMedia() {
        if (this.currentMediaIndex <= 0) {
          this.currentMediaIndex = this.media.length;
        } else {
          this.currentMediaIndex -= 1;
        }
      },
      bindCloseEvent() {
        document.body.addEventListener('click', function (event) {
          const targetEl = event.target;
          const hasProperParent = getClosest(
            event.target,
            '.yotpo-lightbox-container',
          );

          if (targetEl.classList.contains('sr-only') && hasProperParent) {
            const wrapper = getClosest(targetEl, '.yotpo-lightbox-wrapper');
            const closeWrapper = wrapper.querySelector('.yotpo-close-modal');

            closeWrapper.querySelector('span').click();
          }
        });
      },
    },
  });
